import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=751a17aa&"
import script from "./DashboardButton.vue?vue&type=script&lang=js&"
export * from "./DashboardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports